import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

// import sections
import ReactGA from "react-ga4";
import ScrollReveal from "../../utils/ScrollReveal";
import Seo from "../../seo/Seo";
import GetInTouch from "../../components/sections/contact-us/GetInTouch";

const trackPage = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};

const ContactUs = () => {
  const childRef = useRef();
  let location = useLocation();
  const page = location.pathname;

  useEffect(() => {
    document.body.classList.add("is-loaded");
    childRef.current.init();
    trackPage(page);
  }, [location, page]);

  return (
    <>
      <Seo
        title="Contact Us"
        description="Get in touch with Trade Square — Bangkok, Thailand. Reach us by email, phone, or the contact form for project enquiries."
        canonical="/contact-us"
      />
    <ScrollReveal
      ref={childRef}
      children={() => (
        <React.Fragment>
          {/* {page} */}
          <div className="bg-top" />
          <GetInTouch id="GetInTouch" />
          <div className="bg-bottom" />
        </React.Fragment>
      )}
    />
    </>
  );
};

export default ContactUs;
